module.exports = __webpack_public_path__ + "img/ico-selling-beginning.0f071f51.svg";